<template>
  <div class="topic-manage-wrapper">
    <topic-list v-if="componentsName === 'list'" @topicEdit="edit"></topic-list>
    <edit v-if="componentsName === 'edit'" :topicObj="editItem" @back="backList"></edit>
  </div>
</template>
<script>
import Edit from './components/Edit.vue'
import TopicList from './components/List.vue'

export default {
  name: 'paperManagement',
  data() {
    return {
      editItem: null,
      componentsName: 'list'
    }
  },
  methods: {
    edit(item) {
      this.componentsName = 'edit'
      this.editItem = item
    },
    backList() {
      this.componentsName = 'list'
    }
  },
  components: {
    Edit,
    TopicList
  }
}
</script>

<style lang="scss">
.topic-manage-wrapper {
  padding: 0 18px;
  height: calc(100vh - 130px);
}
</style>
